import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DisableControlDirective } from './disable-control.directive';
import { AutocompleteDirective } from './disable-autocomplete.directive';
import { DropFileDirective } from './drop-file.directive';

@NgModule({
  declarations: [
    DisableControlDirective,
    AutocompleteDirective,
    DropFileDirective,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    DisableControlDirective,
    AutocompleteDirective,
    DropFileDirective
  ]
})
export class DirectiveModule { }
